<template>
  <div>
    <v-card outlined tile>
      <v-card-title><strong>{{ name }}</strong></v-card-title>
      <hr class="m-0">
      <v-card-text>
        <h5>{{ data.count }}</h5>
        <v-simple-table>
          <tr>
            <td>Target Achievement</td>
            <td :class="data.target < 0 ? 'text-danger' : 'text-success'">{{ data.target }}%</td>
          </tr>
          <tr>
            <td>Change from Last Year</td>
            <td :class="data.last < 0 ? 'text-danger' : 'text-success'">{{ data.last }}%</td>
          </tr>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    name: {
      type: String,
      default: 'Title'
    },
    data: {
      type: Object,
      required: true
    },
    count: {
      type: Boolean,
      required: true
    },
    setColors: {
      type: Array,
      required: false
    },
    height: {
      type: Number,
      default: 350
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 350,
          type: 'bar'
        },
        plotOptions: {
          bar: {
            horizontal: true,
          }
        },
        colors: this.setColors,
        dataLabels: {
          formatter: function (val, opt) {
            const goals =
              opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
                .goals

            if (goals && goals.length) {
              return `${val} / ${goals[0].value}`
            }
            return val
          }
        },
        legend: {
          show: false,
        }
      },
    }
  },
  computed: {
  },
  methods: {

    colored(value) {
      return value < 0 ? 'red' : 'green'
    }
  }
}
</script>